


































































































































import { Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import { getEnvVar } from '@/utils'
import { PrivatePatient } from '@/types/user'
import { PrivatePatientPatchPayload } from '@/api/user/types'
import InstitutionInputGroup, {
  InstitutionInputs
} from './InstitutionInputGroup.vue'
import CareserviceInputGroup, {
  CareserviceInputs
} from './CareserviceInputGroup.vue'
import * as gender from '@/constants/userGender'
import { isCordovaEnvironment } from '@/utils/cordova'

const extractPatchPayload = (inputs: PrivatePatient) => {
  const {
    lastName,
    firstName,
    lastNameReading,
    firstNameReading,
    gender,
    birthDate,
    postCode,
    addressPrefCode,
    addressCity,
    addressStreet,
    addressEtc,
    phoneNumber,
    medInsurerName,
    medInsurerNumber,
    medInsuredNumber,
    careInsurerName,
    careInsurerNumber,
    careInsuredNumber,
    hasAllergy,
    allergy,
    careLevel,
    contacts,
    institution1Name,
    institution2Name,
    institution3Name,
    institution1PatientId,
    institution2PatientId,
    institution3PatientId,
    careservice1Name,
    careservice2Name,
    careservice3Name,
    careservice1ContractId,
    careservice2ContractId,
    careservice3ContractId,
    freeComment
  } = inputs

  return {
    lastName,
    firstName,
    lastNameReading,
    firstNameReading,
    gender,
    birthDate,
    postCode,
    addressPrefCode,
    addressCity,
    addressStreet,
    addressEtc,
    phoneNumber,
    medInsurerName,
    medInsurerNumber,
    medInsuredNumber,
    careInsurerName,
    careInsurerNumber,
    careInsuredNumber,
    hasAllergy,
    allergy,
    careLevel,
    contacts,
    institution1Name,
    institution2Name,
    institution3Name,
    institution1PatientId,
    institution2PatientId,
    institution3PatientId,
    careservice1Name,
    careservice2Name,
    careservice3Name,
    careservice1ContractId,
    careservice2ContractId,
    careservice3ContractId,
    freeComment
  }
}

@Component({
  components: {
    PostCodeInputGroup: () => import('./PostCodeInputGroup.vue'),
    ContactInputGroup: () => import('./ContactInputGroup.vue'),
    BirthDateSelectInputGroup: () => import('./BirthDateSelectInputGroup.vue'),
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue'),
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue'),
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue'),
    InstitutionInputGroup,
    CareserviceInputGroup
  },
  filters: {
    gender: (value: string): string => {
      return (
        [
          { value: gender.GENDER_F, label: gender.GENDER_F_TEXT },
          { value: gender.GENDER_M, label: gender.GENDER_M_TEXT }
        ].find(v => v.value == value)?.label || ''
      )
    },
    prefecture(value: string) {
      return [
        { value: '01', text: '北海道' },
        { value: '02', text: '青森県' },
        { value: '03', text: '岩手県' },
        { value: '04', text: '宮城県' },
        { value: '05', text: '秋田県' },
        { value: '06', text: '山形県' },
        { value: '07', text: '福島県' },
        { value: '08', text: '茨城県' },
        { value: '09', text: '栃木県' },
        { value: '10', text: '群馬県' },
        { value: '11', text: '埼玉県' },
        { value: '12', text: '千葉県' },
        { value: '13', text: '東京都' },
        { value: '14', text: '神奈川県' },
        { value: '15', text: '新潟県' },
        { value: '16', text: '富山県' },
        { value: '17', text: '石川県' },
        { value: '18', text: '福井県' },
        { value: '19', text: '山梨県' },
        { value: '20', text: '長野県' },
        { value: '21', text: '岐阜県' },
        { value: '22', text: '静岡県' },
        { value: '23', text: '愛知県' },
        { value: '24', text: '三重県' },
        { value: '25', text: '滋賀県' },
        { value: '26', text: '京都府' },
        { value: '27', text: '大阪府' },
        { value: '28', text: '兵庫県' },
        { value: '29', text: '奈良県' },
        { value: '30', text: '和歌山県' },
        { value: '31', text: '鳥取県' },
        { value: '32', text: '島根県' },
        { value: '33', text: '岡山県' },
        { value: '34', text: '広島県' },
        { value: '35', text: '山口県' },
        { value: '36', text: '徳島県' },
        { value: '37', text: '香川県' },
        { value: '38', text: '愛媛県' },
        { value: '39', text: '高知県' },
        { value: '40', text: '福岡県' },
        { value: '41', text: '佐賀県' },
        { value: '42', text: '長崎県' },
        { value: '43', text: '熊本県' },
        { value: '44', text: '大分県' },
        { value: '45', text: '宮崎県' },
        { value: '46', text: '鹿児島県' },
        { value: '47', text: '沖縄県' }
      ].find(v => v.value == value)?.text
    },
    hasAllergy(value: boolean): string {
      return value ? 'あり' : 'なし'
    }
  }
})
export default class PatientProfileForm extends mixins(Form) {
  @Prop(Object) patientInfo!: PrivatePatient

  $store!: ExStore
  inputs = { ...this.patientInfo }

  institutions = this.createInitialInstitutionInputs()
  careservices = this.createCareserviceInputs()

  get errorMessages() {
    return Object.keys(this.validator.messages)
      .map(key => this.validator.messages[key])
      .filter(message => message)
  }

  get genderOptions() {
    return [
      { value: gender.GENDER_F, label: gender.GENDER_F_TEXT },
      { value: gender.GENDER_M, label: gender.GENDER_M_TEXT }
    ]
  }

  get profileEditPath() {
    const manageUrl = getEnvVar('MANAGE_ENDPOINT')
    const heartlineId = this.$store.getters['user/userInfo']['heartlineId']
    const token = localStorage.getItem('token') || ''
    return `${manageUrl}accounts/contract_login/?heartline_id=${heartlineId}&access_token=${token}`
  }

  createInitialInstitutionInputs() {
    const inputs: Array<InstitutionInputs> = []

    for (let i = 3; i >= 1; i--) {
      const name = this.patientInfo[
        `institution${i}Name` as
          | 'institution1Name'
          | 'institution2Name'
          | 'institution3Name'
      ]
      const patientId = this.patientInfo[
        `institution${i}PatientId` as
          | 'institution1PatientId'
          | 'institution2PatientId'
          | 'institution3PatientId'
      ]
      if (!name && !patientId) {
        continue
      }
      inputs.splice(0, 0, { name, patientId })
    }

    return inputs
  }

  createCareserviceInputs() {
    const inputs: Array<CareserviceInputs> = []

    for (let i = 3; i >= 1; i--) {
      const name = this.patientInfo[
        `careservice${i}Name` as
          | 'careservice1Name'
          | 'careservice2Name'
          | 'careservice3Name'
      ]
      const contractId = this.patientInfo[
        `careservice${i}ContractId` as
          | 'careservice1ContractId'
          | 'careservice2ContractId'
          | 'careservice3ContractId'
      ]
      if (!name && !contractId) {
        continue
      }
      inputs.splice(0, 0, { name, contractId })
    }

    return inputs
  }

  buildPayload(): PrivatePatientPatchPayload {
    const institutions = this.institutions.filter(institution =>
      Object.keys(institution).some(
        key => institution[key as keyof InstitutionInputs]
      )
    )
    ;[0, 1, 2].forEach(index => {
      if (institutions[index]) {
        ;(this.inputs as any)[`institution${index + 1}Name`] =
          institutions[index].name
        ;(this.inputs as any)[`institution${index + 1}PatientId`] =
          institutions[index].patientId
      } else {
        ;(this.inputs as any)[`institution${index + 1}Name`] = null
        ;(this.inputs as any)[`institution${index + 1}PatientId`] = null
      }
    })
    const careservices = this.careservices.filter(careservice =>
      Object.keys(careservice).some(
        key => careservice[key as keyof CareserviceInputs]
      )
    )
    ;[0, 1, 2].forEach(index => {
      if (careservices[index]) {
        ;(this.inputs as any)[`careservice${index + 1}Name`] =
          careservices[index].name
        ;(this.inputs as any)[`careservice${index + 1}ContractId`] =
          careservices[index].contractId
      } else {
        ;(this.inputs as any)[`careservice${index + 1}Name`] = null
        ;(this.inputs as any)[`careservice${index + 1}ContractId`] = null
      }
    })

    return extractPatchPayload(this.inputs)
  }

  handleSubmit() {
    if (this.validator.hasAnyError()) {
      return
    }

    const patientPatchPayload = this.buildPayload()

    this.$store.commit('user/setSessionData', { patientPatchPayload })

    this.$router.push({ name: 'PatientProfileConfirm' })
  }

  handleClickEdit() {
    const url = this.profileEditPath
    if (isCordovaEnvironment()) {
      this.$postMessage.openExternalUrl(url)
    } else {
      window.open(url, '_blank')
    }
  }
}
